const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.873497,32.99556237246704L2,32.99556237246704L2,16.46387317246704C2,15.072570572467042,3.1839833,13.942690372467041,4.6419077,13.942690372467041C6.0998321,13.942690372467041,7.2838154,15.07256957246704,7.2838154,16.46387317246704L7.2838154,27.95319937246704L15.873497,27.95319937246704C17.331422,27.95319937246704,18.515404,29.08307637246704,18.515404,30.47438337246704C18.515404,31.86568537246704,17.331422,32.99556237246704,15.873497,32.99556237246704Z",
    fill: "#333333",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.66510772705078,
    y: 14.24013090133667,
    width: 5.334888458251953,
    height: 18.742706298828125,
    rx: 2.6674442291259766,
    fill: "#333333",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.95713696777344,32.916554288635254L70.74992556777343,32.916554288635254C69.29200156777344,32.916554288635254,68.10801696777344,31.786681288635254,68.10801696777344,30.395371288635253C68.10801696777344,29.004072288635253,69.29200156777344,27.874191288635252,70.74992556777343,27.874191288635252L80.01285396777344,27.874191288635252C82.46903296777344,27.874191288635252,84.56770496777344,26.053093288635253,84.66056596777344,23.709147488635253C84.75807196777343,21.245565888635255,82.68725796777343,19.211782888635256,80.12428196777344,19.211782888635256L68.11265748877344,19.211782888635256L68.11265748877344,14.169419288635254L80.12428196777344,14.169419288635254C85.60310596777344,14.169419288635254,90.04652196777343,18.471823688635254,89.94437596777344,23.722440688635253C89.84222996777343,28.853423288635256,85.33844796777343,32.91212328863526,79.96176996777344,32.91212328863526L79.95713696777344,32.916554288635254Z",
    fill: "#333333",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.10801696777344,
    y: 14.301816463470459,
    width: 5.334888935089111,
    height: 11.888107299804688,
    rx: 2.6674444675445557,
    fill: "#333333",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.33019685745239,
    cy: 9.547767639160156,
    rx: 2.6697659492492676,
    ry: 2.5477676391601562,
    fill: "#333333",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.321036779418947,32.99556237246704C21.389519269418944,32.99556237246704,20.098745879418946,31.09914037246704,20.878780229418947,29.415396372467043L27.137639479418944,15.936595872467041C27.699451879418945,14.72252899246704,28.957725479418947,13.942690372467041,30.350645979418946,13.942690372467041L33.90724127941895,13.942690372467041L25.763294179418946,31.48019837246704C25.336131579418947,32.401825372467044,24.379658479418946,32.99556237246704,23.321036779418947,32.99556237246704Z",
    fill: "#333333",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.877688889331054,16.00381460226865L31.957197189331055,22.291262165368654L36.22418068933106,31.476519065368652C36.65134188933106,32.39814306536866,37.60781668933105,32.99188706536865,38.66643668933106,32.99188706536865C40.59795568933106,32.99188706536865,41.88872908933105,31.095461065368653,41.10869218933105,29.411717065368652L34.882336589331054,15.999381065368652L34.877688889331054,16.00381460226865Z",
    fill: "#333333",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.62310626293945,15.963182972729491L51.026465462939456,26.08336167272949C50.64108996293945,26.92966367272949,49.317815262939455,26.668241672729494,49.317815262939455,25.746614672729493L49.317815262939455,16.769607972729492C49.317815262939455,15.294117772729493,48.13383056293945,14.040172867729492,46.592331362939454,13.951554503729492C44.90689776293945,13.854074567729493,43.50468826293945,15.130174172729493,43.50468826293945,16.720867372729494L43.50468826293945,27.589870672729493C43.50468826293945,30.576295672729493,46.04444866293945,32.99999967272949,49.173877762939455,32.99999967272949C50.89645626293945,32.99999967272949,52.614396062939456,32.03406367272949,53.310855862939455,30.53198667272949L61.01370826293945,13.951555349429492L58.84539626293945,13.951555349429492C57.447830262939455,13.951555349429492,56.18027326293945,14.744687142729493,55.62310326293945,15.972045872729492L55.62310626293945,15.963182972729491Z",
    fill: "#333333",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.05242606464844,32.99556237246704C61.658932164648434,32.99556237246704,62.95898626464844,31.75491037246704,62.95898626464844,30.221819372467042L62.95898626464844,13.942690372467041L57.14585876464844,26.47770937246704L57.14585876464844,30.217388372467042C57.14585876464844,31.750477372467042,58.44592036464844,32.99113137246704,60.05242256464844,32.99113137246704L60.05242606464844,32.99556237246704Z",
    fill: "#333333",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.14221a069ee2bdb355f0e7c29c587795.svg";
export { ForwardRef as ReactComponent };